import * as Yup from 'yup';

import { FormPage } from 'components/page';
import { useLoaderContext } from 'context/LoaderContext';
import { LocalFuncionarioGeneralBlock } from 'pages/complementar/local-funcionario/components';
import { usePostLocalFuncionario } from 'pages/complementar/local-funcionario/hooks';

export function LocalFuncionarioFormComp() {
    const { handleSubmit, isLoading } = usePostLocalFuncionario();

    useLoaderContext(isLoading);

    const validationSchema = Yup.object({
        cdLocalFuncionario: Yup.string().required(),
        dsLocalFuncionario: Yup.string().required(),
        dsTransportadora: Yup.string().required(),
        vlFrete: Yup.number()
            .when(['fgFreteGratis', 'fgRetirada'], {
                is: (fgFreteGratis: boolean, fgRetirada: boolean) => !fgFreteGratis && !fgRetirada,
                then: (schema) => schema.moreThan(0, 'O valor do frete deve ser maior que 0.'),
            })
            .nullable(),
        cep: Yup.object().shape({
            nrCep: Yup.string().length(8, 'O campo deve ter exatamente 8 números.').required(),
        }),
    });

    return (
        <FormPage
            fgAtivo
            goBackButton
            url="/gestao/localfuncionario/"
            title="Local de Funcionário"
            values={{ fgAtivo: true, vlFrete: 0 }}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
        >
            <LocalFuncionarioGeneralBlock />
        </FormPage>
    );
}
